export default __webpack_public_path__ + "static/media/audio_46_martillo_madera.60776cae.mp3";